// GAVION commissions: Rapports → Commissions, the statement page and « Mes commissions ».
export const commissionsReportsEn = {
  title: "Commissions",
  description:
    "Commission statements per person, the amounts preview and the history per client.",
  statements: {
    title: "Statements",
    person: "Person",
    cutoff: "Up to",
    preview: "Preview",
    create: "Create a statement",
    created: "Statement created",
    empty: "No statement.",
    open: "Statement of %{cutoff}",
    choose_person: "Choose a person.",
    preview_empty: "No commission or bonus up to that date.",
    total: "Total: %{amount}",
    to_pay: "To pay for this period: %{amount}",
    to_settle:
      "To settle with the employee (never deducted, outside the payout): %{amount}",
  },
  table: {
    month: "Month",
    client: "Client",
    person: "Person",
    kind: "Kind",
    mrr: "MRR collected",
    subscription_month: "Subscription month",
    split: "Share",
    rate: "Rate",
    amount: "Amount",
    explanation: "Explanation",
    caption_preview: "Statement preview (what is left to pay)",
    caption_client: "Lines of %{name}",
    record_split: "Record the split",
    base_hidden: "Base hidden",
  },
  checks: {
    title: "To check",
    won_without_subscription: "Won opportunities without a subscription",
    without_source:
      "Subscriptions whose sale source is missing (no commission)",
    none: "Nothing to check.",
  },
  history: {
    title: "History per client",
    client: "Client",
    empty: "No earnings for this client.",
  },
  statement: {
    title: "Commission statement — %{name}",
    cutoff: "Up to %{date}",
    paid_on: "Paid on %{date}",
    loading: "Loading the statement…",
    refresh: "Refresh",
    refreshed: "Statement refreshed",
    delete: "Delete the draft",
    confirm_delete: "Delete this draft statement?",
    deleted: "Statement deleted",
    mark_paid: "Mark as paid",
    paid_on_label: "Payout date",
    note: "Note",
    confirm_paid: "Confirm the payout",
    paid: "Statement paid: it will no longer change.",
    export: "Export (CSV)",
    print: "Print",
    fees: "One-time fees (information, no commission)",
    subtotal: "Subtotal: %{amount}",
    total: "Statement total (paid): %{amount}",
    to_settle_title:
      "To settle with the employee (withholding only with written consent)",
    to_settle_help:
      "A refund or a correction after a paid month is never deducted from a payout. Settle it with the employee (written consent for a withholding, a refund, or waive it), then mark it settled.",
    to_settle_total: "To settle (outside the total): %{amount}",
    vacation_pay: "Vacation pay %{pct}% (for payroll): %{amount}",
    vacation_pay_help:
      "Information for payroll, not included in the total (on %{base} paid).",
    settle: "Mark settled",
    settle_note:
      "How it was settled (e.g. withholding authorized in writing on …)",
    settle_confirm: "Confirm",
    settle_done: "Marked settled",
    settled: "Settled on %{date} · %{kind} · %{note}",
    settle_kind: "How",
    settlement_kinds: {
      retenue: "Withheld (written consent)",
      rembourse: "Paid back by the employee",
      abandonne: "Waived",
      annule: "Cancelled by a correction",
    },
    not_settled: "Not settled yet",
    cancelled_pending:
      "Cancelled by a correction now due: nothing to settle (closed at the next payout). If it was already paid back or withheld, record it: the next statement pays it back.",
    no_lines: "No line.",
    base_hidden:
      "On the sales where you are neither the Closer nor the Account manager, only your amount is shown (not the client's MRR, the split or the rate).",
    pending_rep:
      "%{smart_count} « To decide » line awaits a decision on the split (art. 4.5.6): it is not on this statement, neither paid nor lost. |||| %{smart_count} « To decide » lines await a decision on the split (art. 4.5.6): they are not on this statement, neither paid nor lost.",
    pending:
      "%{smart_count} « To decide » line: the contract does not settle this split (art. 4.5.6). It is not on this statement (neither paid nor lost), which can be paid; record the agreed split on the opportunity and it goes on the next statement. |||| %{smart_count} « To decide » lines: the contract does not settle this split (art. 4.5.6). They are not on this statement (neither paid nor lost), which can be paid; record the agreed split on the opportunity and they go on the next statement.",
  },
  mine: {
    title: "My commissions",
    description: "Your commission statements, read only.",
    empty: "No statement yet.",
    item: "Statement of %{cutoff}",
  },
};
